import { Inject, Injectable, Optional } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import {
  NgxMatMomentAdapter,
  NgxMatMomentDateAdapterOptions,
  NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@ngxmc/moment-adapter';

/**
 * Fixes a bug in NgxMatMomentAdapter where setLocale() updates _localeData
 * but not dateLocale, causing the adapter to use the stale initial locale.
 */
@Injectable()
export class CustomNgxMatMomentAdapter extends NgxMatMomentAdapter {
  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
    @Optional()
    @Inject(NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS)
    options?: NgxMatMomentDateAdapterOptions
  ) {
    super(dateLocale, options);
  }

  override setLocale(locale: string): void {
    super.setLocale(locale);
    (this as Record<string, unknown>)['dateLocale'] = locale;
  }
}
